<template>
  <TransactionsGetter
    :searchText="typedSearchValue"
    :cursorIndex="cursorIndex"
    @loading="setPageIsLoading"
    @result="
      data => {
        payments = data
        this.isLoading = false
      }
    "
  />
  <ListComponent
    v-if="transactions.length"
    class="relative h-full overflow-auto"
    :itemContainerHeight="70"
    itemContainerWidth="100%"
    :itemsClasses="[]"
    directUseItems
    :allItems="transactions"
    scrollContainerSelector=""
    id="lol"
    ref="list"
    :loadingMoreEnd="false"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template v-slot="slotData">
      <div
        v-if="slotData"
        class="px-6 flex h-full items-center ripple"
        @click="showTransactionDetails(slotData.data.item)"
      >
        <div
          class="flex gap-2 items-center w-full"
          v-if="slotData.data?.item?.reference || slotData.data?.item?.shimmer"
        >
          <div
            class="w-16 h-16 rounded-[14px] overflow-hidden"
            :class="{
              shimmerElementRoundedDefault: slotData.data.item.shimmer,
            }"
          >
            <img :src="slotData.data.item.logo" alt="" class="w-full h-full" />
          </div>
          <div class="pt-2">
            <div
              class="font-medium text-lg title-description-color"
              :class="{
                'shimmerElement h-4 min-w-[calc(100vw-100px)] mb-2':
                  slotData.data.item.shimmer,
              }"
            >
              {{ slotData.data.item.operationNameDisplay }}
            </div>
            <div
              class="font-medium description-color -top-1 relative"
              :class="{
                'shimmerElement h-4 min-w-[calc(100vw-100px)] mb-1':
                  slotData.data.item.shimmer,
              }"
            >
              {{ slotData.data.item.startDate }}
            </div>
          </div>
          <div class="ml-auto text-end title-description-color font-medium">
            <div>
              {{ slotData.data.item.amountToReceive }}
              {{ slotData.data.item.currencyToReceive }}
            </div>
            <div class="-top-1 relative-top-1 relative">
              {{ slotData.data.item.operationTypeDisplay }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </ListComponent>
  <div class="w-full h-full flex-col flex items-center" v-else>
    <slot name="header" />

    <div class="w-2/3 pb-64 pt-8">
      <LottieComponent content="emptyTransactions" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListComponent from '@/components/utils/ListComponentVirtualScroll.vue'
import LottieComponent from '@/components/utils/LottieComponent.vue'
import TransactionsGetter from './TransactionsGetter.vue'

export default defineComponent({
  name: 'TransactionListComponent',
  components: { ListComponent, LottieComponent, TransactionsGetter },
  props: {
    sourceData: {
      type: String,
      default: 'transactions',
    },
    updateEventToListen: {
      type: String,
      default: 'transactions_updated',
    },
  },
  data() {
    return {
      shimmerTransactions: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      transactions: [],
      eventsIds: [],
    }
  },
  mounted() {
    // return;
    this.transactions = JSON.parse(JSON.stringify(this.shimmerTransactions))
    this.loadTransactions()
    const id = this.$Events.handleEvent(
      this.updateEventToListen,
      this.loadTransactions,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
    this.unsubscribeToResponseListener()
  },
  methods: {
    async loadTransactions() {
      this.unsubscribeToResponseListener()
      const { unsubscribe } = this.$Events.sendDataRequest(
        this.sourceData,
        this.onTransactionsGot,
      )
      this.unsubscribeToResponseListener = unsubscribe
    },
    unsubscribeToResponseListener() {},
    onTransactionsGot(transactions) {
      if (!transactions) return
      this.transactions = transactions
      // this.transactions = Object.freeze(transactions)
    },
    showTransactionDetails(transaction) {
      if (!transaction || !transaction?.reference) return
      this.$Events.dispatchEvent('transaction_details_requested_bottomsheet', {
        reference: transaction.reference,
      })
    },
  },
})
</script>
